import { useTranslation } from 'react-i18next';

import { Button } from '../Button';
import { Reset } from '../Icons';

interface Props {
  isLoading: boolean;
  heading: string;
  hasChanges?: boolean;
  isDisabled?: boolean;
  onReset?: () => void;
  formName?: string;
}

export const SectionFormHeading = ({ isLoading, heading, hasChanges = false, onReset: onCancel, isDisabled, formName }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <div className="sticky top-[--headerHeight] z-topBar flex w-full items-center justify-between gap-4 bg-neutral-96 py-3 transition-all group-[.scrollingDown]/body:top-0 lg:pb-7 lg:pt-7">
      <h2 className="heading-2 sm:heading-1">{heading}</h2>
      <div className="flex gap-2">
        <Button color="secondary" variant="bordered" icon={Reset} disabled={isLoading || isDisabled || !hasChanges} onClick={onCancel}>
          {t('common:reset')}
        </Button>
        <Button type="submit" isLoading={isLoading} disabled={isDisabled} form={formName}>
          {t('common:save')}
        </Button>
      </div>
    </div>
  );
};
